/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  code3Formatter,
  createDefaultGridModel,
  ROW_DIRTY_CLASS,
} from '@gh/common-internal-shared';
import { queryFormEditable, State } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { GridModel, GridOptionsExt, ManualGridDefinitionWithModel } from '@gh/core-ui-grid';
import { ColDef } from 'ag-grid-community';
import { isNil } from 'lodash';
import { getPbCostCenterId } from '../../../resources/price-book.model';
import { PbDetailsState } from '../pb-details.state';

@Injectable()
export class PBDetailsCcGridDefinition extends ManualGridDefinitionWithModel {
  constructor(private translationService: TranslationService,
              private state: State<PbDetailsState>) {
    super();
  }

  buildGridModel(): GridModel {
    return createDefaultGridModel({
      editable: this.state.project(queryFormEditable),
      getId: getPbCostCenterId,
    });
  }

  buildGridOptions(): GridOptionsExt {
    return {
      rowSelection: { mode: 'singleRow', enableClickSelection: true, checkboxes: false },
      defaultColDef: {
        sortable: false,
      },
      rowClassRules: {
        [ROW_DIRTY_CLASS]: ({ data }: { data: PbDetailsState }) => !isNil(data.dirtyType),
      },
    };
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'code',
      headerName: this.translationService.get('lbl_number'),
      width: 100,
      sort: 'asc',
      valueFormatter: code3Formatter,
    }, {
      field: 'name',
      headerName: this.translationService.get('lbl_description'),
    }];
  }
}
